// extracted by mini-css-extract-plugin
export default {"container":"ImageForm_container__WmUlm","footer":"ImageForm_footer__8dGaD","add":"ImageForm_add__KnCC+","clear":"ImageForm_clear__3Sg6V"};